Ext.define('SA.data.UserAttributes', {
    singleton: true,

    constructor() {
        this.data = [];
    },

    get(id) {
        return this.data.find(attribute => attribute.attribute === id);
    },

    getAttributes(ids) {
        return ids.map(id => this.get(id));
    },

    getForDataset(dataset) {
        return this.data.filter(attribute => attribute.dataset_series === dataset);
    },

    getIds() {
        return this.data.map(attribute => attribute.attribute);
    },

    isUserAttribute(id) {
        return this.data.some(attribute => attribute.attribute === id);
    },

    async loadAll() {
        var hasDatasets = SA.data.UserDatasets.hasDatasets();

        this.data = hasDatasets ? await fetchAttributes() : [];

        return this.getIds();

        function fetchAttributes() {
            var where = ['in', 'dataset_series', SA.data.UserDatasets.getIds()],
                fields = SA.data.AttributesCache.getFields(),
                query = new SA.data.AttributesQuery({where, fields, limit: 100000, userData: true});

            query.run();

            return new Promise(resolve => {
                query.addSuccess(({results}) => resolve(results));
            });
        }
    },

    async removeForDataset(dataset) {
        var attributes = this.getForDataset(dataset).map(({attribute}) => attribute);

        await Promise.all([
            SA.data.RecentAttributes.remove(attributes),
            SA.data.FavoriteAttributes.remove(attributes),
            SA.data.Projects.removeAttributes(attributes)
        ]);

        this.data = this.data.filter(attribute => attribute.dataset_series !== dataset);
    },

    updateDatasetName(dataset, name) {
        this.getForDataset(dataset).forEach(attribute => attribute.group = name);
    }
});